import styles from '@components/InspiratioNoResultsFound/InspiratioNoResultsFound.styles';
type PropsType = {
  text1: string;
  text2: string;
};
const InspirationListingHeader = ({
  text1,
  text2
}: PropsType) => {
  return <div sx={styles.noResultsFoundContainer}>
      <p>{text1}</p>
      <p>{text2}</p>
    </div>;
};
export default InspirationListingHeader;